export default __webpack_public_path__ + "static/media/5197057.7122dfae.jpg";